import { controls,grouped } from "../controls";
const account_installments = {
label: "Account Installments",
pageLabel: "Account Installments",starting: true,url: "autogen",
formActions: { edit: { allow: true },delete:{allow:false} },
pageType: "history",
filter:[
...controls.magicDateLabel({ tab: "filter", label: "First Installment Date",target: "first_installment_date"}),
...controls.magicDate({ tab: "filter", name: "first_installment_date", dateType: "ontype" }),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Installment Amount"}),
...controls.floatOnly({ tab: "filter",  placeHolder: "", name: "installment_amount",maxlength:21}),
...controls.displayText({ tab: "filter",  label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Number Of Installments"}),
...controls.numberOnly({ tab: "filter",  placeHolder: "", name: "number_of_installments",maxlength:200}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Installment Freq"}),
...controls.autoComplete({tab: "filter", name: "AccountInstallment-installment_frequency-installment_freq_code", width: "col-sm-2",controlType: "InstallmentFrequency"}),
...controls.displayText({ tab: "filter", label: ""}),
...controls.displayText({ tab: "filter", label: "Installment Type"}),
...controls.oc({ tab: "filter", c: "InstallmentType", placeHolder: "Installment Type Code", name: "AccountInstallment-installment_type-installment_type_code",fastpath: "installment_types"}),
...controls.showData({ tab: "filter", displaytype: "capital", data: "AccountInstallment-installment_type-installment_type_display"}),
]
,form:[
...controls.magicDateLabel({ tab: "general", label: "As On Date",target: "as_on_date",star:false}),
...controls.magicDate({ tab: "general", name: "as_on_date", dateType: "ontype" ,isReadOnly:"edit"  }),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.magicDateLabel({ tab: "general", label: "First Installment Date",target: "first_installment_date",star:true}),
...controls.magicDate({ tab: "general", name: "first_installment_date", dateType: "ontype",isRequired:true ,isReadOnly:"edit"  }),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Number Of Installments",star:true}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "number_of_installments",isRequired:true,maxlength:200 ,isReadOnly:"edit" }),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Installment Freq",star:true}),
...controls.autoComplete({tab: "general", name: "installment_freq_code", width: "col-sm-2",controlType: "InstallmentFrequency"}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Installment Type",star:true}),
...controls.oc({ tab: "general", c: "InstallmentType", placeHolder: "Installment Type Code", name: "installment_type_code",isRequired:true,fastpath: "installment_types" ,isReadOnly:"edit" ,hidden:false}),
...controls.showData({ tab: "general", displaytype: "capital", data: "installment_type_display"}),
...controls.displayText({ tab: "general", label: "Moratorium Period",star:false}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "moratorium_period",maxlength:200 ,isReadOnly:"edit" }),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Installment Amount"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "installment_amount",maxlength:18 ,isReadOnly:"edit" }),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
]
,history:{
perPage: 10,
reportHeader: "Account Installments",
pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
clickable: true,
displayColumns: [
{Header: "Sr",type: "autoinc",accessor: "srno",align: "center",width: 30},
{Header: "First Installment Date",accessor: "first_installment_date",type:'date'},
{Header: "Installment Amount",accessor: "installment_amount",},
{Header: "Number Of Installments",accessor: "number_of_installments",},
{Header: "Installment Freq",accessor: "AccountInstallment-installment_frequency-installment_freq_display",},
{Header: "Installment Type",accessor: "AccountInstallment-installment_type-installment_type_display",},
]}};
export default account_installments;